import {
  createLoad,
  editLoad,
  editLoadList,
  getLoadById,
  getCustomerLoads,
  searchCustomerReceivables,
  filterByAlphabeticalReceivables,
  filterByDefaultReceivables,
  getCarrierLoads,
  getLoadTransactions,
  getLoadsByStatus,

  editOpenPayablesTable,

  getBatches,
  getAllBatches,
  createBatch,
  editBatchTable,
  editBatchList,
  getLoadsPayableBatches,
  deleteLoadsPayableBatches,
  moveLoadsPayableBatches,
  removeLoadsPayableBatches,

  sendToPayable,
  approvePayable,
  getLoadsByPayable,
  getReceivablesInfo,
  getPastPayable,
  getPastBill,
  reBill,
  cancelLoad,
  searchList,
  removeSearchedList,
  getCarrierLastLoads,
  getLoadCarrierTransactions,
  createLoadTemplate,
  getLoadOtherTransactions,
  getLoadTotals,
  getRecNotes,
  createRecNote,
  editRecNote,
  deleteRecNote,
  getPayableInfo,
  uploadLoadList,
  createCustomerOrder,
  editCustomerOrder,
  deleteCustomerOrder,
  getGroupedLoads,
  getGroupById,
  getGroupLoads,
  cancelGroup,
  getGroupPayableLoads,
  getGroupLoadsTxns,
  removeLoadById,
  sendToCarrierEmail,
  setAsBadDept,
  createPayableNote,
  editPayableNote,
  deletePayableNote,
  getBillingGroups,
  getBillingPrepaidLoads,
  getBillingGroupLoads,
  getCorporateTxns,
  pauseGroupLoadBilling,
  getShortOverpay,
  setPrepayBilled,
  getReceivableCustomersForSelect,
} from './loads.action';
import axios from 'axios';

export { loadReducer } from './loads.reducer';
export { watchLoad } from './loads.saga';

export const loadActions = {
  /** Create, Edit Load */
  createLoad,
  createLoadTemplate,
  editLoad,
  editLoadList,
  cancelLoad,
  /** End */

  /** Get Loads */
  getLoadTotals,
  getLoadsByStatus,

  /** Edit Payables Table */
  editOpenPayablesTable,
  /** End */

  /** Bacth */
  getBatches,
  getAllBatches,
  createBatch,
  editBatchTable,
  editBatchList,
  getLoadsPayableBatches,
  deleteLoadsPayableBatches,
  moveLoadsPayableBatches,
  removeLoadsPayableBatches,

  getCustomerLoads,
  getCarrierLoads,
  getCarrierLastLoads,
  getLoadById,
  removeLoadById,
  getLoadsByPayable,
  getReceivablesInfo,
  getPayableInfo,
  setAsBadDept,
  /** End */

  /** Carriers CarrierPayment */
  searchCustomerReceivables,
  filterByAlphabeticalReceivables,
  filterByDefaultReceivables,
  /** End */

  /** Load Transactions */
  getLoadTransactions,
  getLoadCarrierTransactions,
  getLoadOtherTransactions,
  /** End */

  /** Load Payable */
  sendToPayable,
  approvePayable,

  sendToCarrierEmail,
  /** End */

  /** Pasts */
  getPastPayable,
  getPastBill,
  reBill,
  /** End */

  searchList,
  removeSearchedList,

  /** Receivable Notes */
  createPayableNote,
  editPayableNote,
  deletePayableNote,
  /** End */

  /** Receivable Notes */
  getRecNotes,
  createRecNote,
  editRecNote,
  deleteRecNote,
  /** End */

  uploadLoadList,

  /** Customer Order */
  createCustomerOrder,
  editCustomerOrder,
  deleteCustomerOrder,
  /** End */

  /** Grouped Loads */
  getBillingGroups,
  getBillingGroupLoads,
  getBillingPrepaidLoads,
  setPrepayBilled,
  getGroupedLoads,
  getGroupById,
  getGroupLoads,
  cancelGroup,
  getGroupPayableLoads,
  getGroupLoadsTxns,
  pauseGroupLoadBilling,
  /** End */

  getCorporateTxns,
  getShortOverpay,

  getReceivableCustomersForSelect,
};


export const loadAuthActions = {

  getReceivablesInfoService: (date) => axios.get(`/reports/loads`, { auth: true, params: { ...date } }),

  verifyBilling: (id) => axios.patch(`/loads/${id}/billing/verify`, {}, { auth: true }),

  pmtPending: (id, pmtPending) => axios.patch(`/loads/${id}/pmtPending`, {}, {
    auth: true,
    params: { pendingPmtDate: pmtPending },
  }),

  loadToRevision: (id, comment) => axios.post(`/loads/${id}/revision`, { comment: comment }, { auth: true }),

};